import { ILegalTransactionFullObject } from '../../Interfaces/ILegalTransaction';

/**
 * Aktenzeichen für das Pflichtfeld des Grundbuch-Portals.
 *
 * Fachliche Vorgabe: aus einem Vorgang heraus die Urkundennummer — bei
 * mehreren die erste —, sonst die Vorgangsnummer. Ohne Vorgang (Eigentümer-
 * recherche aus der Grundstücke-Übersicht) bleibt es leer: dort gibt der
 * Mitarbeiter das Aktenzeichen selbst ein.
 */
export const aktenzeichenFromLegalTransaction = (
  legalTransaction?: ILegalTransactionFullObject
): string => {
  if (!legalTransaction) return '';

  const urkundennummer = (legalTransaction.RecordNumberArray ?? [])
    .map(entry => (entry.RecordNumberEntry ?? '').trim())
    .find(entry => entry !== '');
  if (urkundennummer) return urkundennummer;

  return legalTransaction.idLegalTransaction
    ? String(legalTransaction.idLegalTransaction)
    : '';
};
